if(!customElements.get('product-card')){
    class ProductCard extends HTMLElement {
        constructor(){
            super();

            this.imageWrapper = this.querySelector('.product-card__image');
            this.contentWrapper = this.querySelector(".product-card__content");
            
            this.productForm = this.querySelector('product-card-form');
            if(this.productForm){
                this.productFormId = this.productForm.dataset.id;
            }
        }

        connectedCallback(){
            this.onSwatchValueChangeUnsubscriber = PubSub.subscribe(
                PubSub.events.productCardSwatchValueChange, this.handleSwatchValueChange.bind(this)
            );
            this.onSizeValueChangeUnsubscriber = PubSub.subscribe(
                PubSub.events.productCardSizeValueChange, this.handleSizeValueChange.bind(this)
            );

            // product card image slider
            this.initializeSwiper();
        }

        disconnectedCallback() {
            if(this.onSwatchValueChangeUnsubscriber && typeof this.onSwatchValueChangeUnsubscriber === 'function'){
                this.onSwatchValueChangeUnsubscriber();
            }
            if(this.onSizeValueChangeUnsubscriber && typeof this.onSizeValueChangeUnsubscriber === 'function'){
                this.onSizeValueChangeUnsubscriber();
            }
        }

        handleSizeValueChange({ data: { event, target, selectedOptionValues, source }}){
            if (!this.contains(event.target)) return;

            const productUrl = target.dataset.productUrl || this.pendingRequestUrl;
            const productId = target.dataset.optionValueId;
            this.pendingRequestUrl = productUrl;

            this.renderProductInfo({
                requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
                targetId: productId,
                callback: this.updateProductInfo(true)
            });
        }

        handleSwatchValueChange({ data: { event, target, selectedOptionValues, source }}){
            if (!this.contains(event.target)) return;

            const productUrl = target.dataset.productUrl || this.pendingRequestUrl || url;
            const productId = target.dataset.optionValueId || id;
            this.pendingRequestUrl = productUrl;

            this.renderProductInfo({
                requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
                targetId: productId,
                callback: this.updateProductInfo()
            });
        }

        updateProductInfo(sizeUpdate = false){
            return(html) => {
                const selectedVariantJsonData = JSON.parse(html.querySelector('#json-selected-variant').textContent);
                const media = selectedVariantJsonData.featured_media;

                this.updateMedia(media, selectedVariantJsonData.name);
                this.updatePrice(html);
                this.updateComparePriceCheckbox(html);

                if(sizeUpdate){
                    const data = {
                        productFormId: this.productFormId
                    }

                    PubSub.publish(PubSub.events.sizeAddToCart, {
                        data: data
                    });
                }

                this.updateProductForm(html);
            }
        }

        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false){
            const params = [];

            !shouldFetchFullPage && params.push(`section_id=product-card`);

            if(optionValues.length) {
                params.push(`option_values=${optionValues.join(',')}`);
            }

            if(url.includes('?')) return `${url}&${params.join('&')}`;

            return `${url}?${params.join('&')}`;
        }

        renderProductInfo({ requestUrl, targetId, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        updateMedia(media = null, variantName = ''){
            if(!media){
                const selectedVariantImage = this.querySelector('.selected-variant-image');
                if (selectedVariantImage) {
                    selectedVariantImage.remove();
                }
                return;
            }

            // update swiper index if swiper exists
            if(this.swiper && media.id){
                const targetIndex = Array.from(this.slides).findIndex(slide => {
                    return parseInt(slide.dataset.mediaId) === media.id;
                });

                if(targetIndex >= 0 && this.swiper.activeIndex !== targetIndex){
                    this.swiper.slideToLoop(targetIndex);
                }
                return;
            }

            // update selected variant image for non-slider media
            const existingSelectedVariantImage = this.querySelector('.selected-variant-image');
            if(existingSelectedVariantImage){
                existingSelectedVariantImage.remove();
            }

            const mediaURL = media.preview_image?.src;
            if(mediaURL){
                const newDiv = document.createElement('div');
                const newImg = document.createElement("img");
                newImg.src = `${mediaURL}?width=500`;
                newImg.alt = variantName;

                newDiv.classList.add('selected-variant-image', 'w-full', 'h-full', 'absolute', 'top-0', 'left-0', 'changed');
                newImg.classList.add('object-cover', 'w-full', 'h-full', 'pointer-events-none');

                newDiv.appendChild(newImg);
                this.imageWrapper.appendChild(newDiv);
            }
        }

        updatePrice(html){
            const newPriceHTML = html.querySelector('.price');
            const oldPrice = this.querySelector(".price");

            if(newPriceHTML && oldPrice && oldPrice.parentNode){
                oldPrice.parentNode.replaceChild(newPriceHTML.cloneNode(true), oldPrice);
            }
        }

        updateComparePriceCheckbox(html){
            const newComparePriceCheckboxHTML = html.querySelector('.compare-product-checkbox');
            const oldComparePriceCheckbox = this.querySelector('.compare-product-checkbox');
            
            if(newComparePriceCheckboxHTML && oldComparePriceCheckbox && oldComparePriceCheckbox.parentNode){
                oldComparePriceCheckbox.parentNode.replaceChild(newComparePriceCheckboxHTML.cloneNode(true), oldComparePriceCheckbox);
                return;
            }
        }

        updateProductForm(html){
            const newProductFormHTML = html.querySelector(".product-form");
            const oldProductForm = this.querySelector(".product-form");

            if(newProductFormHTML && oldProductForm && oldProductForm.parentNode){
                oldProductForm.parentNode.replaceChild(newProductFormHTML.cloneNode(true), oldProductForm);

                if(!this.productFormId) return;
                
                this.querySelectorAll('.product-form input[type="radio"]').forEach(radio => {
                    radio.setAttribute('form', this.productFormId);
                });
                this.querySelector('.product-form')?.setAttribute('data-id', this.productFormId);
                this.querySelectorAll(".product-form form").forEach(item => {
                    item.id = this.productFormId;
                });
            }
        }

        async initializeSwiper(){
            this.swiperContainer = this.querySelector('.product-card__image-wrapper .swiper-container');
            if(!this.swiperContainer) return;

            this.slides = this.swiperContainer.querySelectorAll('.swiper-slide');
            if(this.slides.length <= 1) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const loop = false;

            const swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true,
                autoHeight: false,
                on: {
                    init: () => {
                        const paginationBullets = this.querySelectorAll(".swiper-pagination-bullet");
                        if(paginationBullets.length > 0){
                            this.style.setProperty('--pagination-width', `calc(100% / ${paginationBullets.length})`);
                            paginationBullets.forEach((item, index) => {
                                item.setAttribute('data-index', `${index}`);
                            });

                            // set pagination color
                            const activeSlide = this.querySelector('.swiper-slide-active');
                            if(activeSlide){
                                const colorText = getComputedStyle(activeSlide).getPropertyValue('--color-text').trim();
                                this.style.setProperty('--color-pagination', `${colorText}`);
                            }
                            setTimeout(() => {
                                this.querySelector('.swiper-pagination')?.classList.add('loaded');
                                this.checkSwiperLock();
                            }, 500);
                        }
                    },
                    slideChange: () => {
                        const activePagination = this.querySelector(".swiper-pagination-bullet-active");
                        if(activePagination){
                            const activePaginationIndex = parseInt(activePagination.dataset.index);
                            this.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                        }
                    },
                    transitionEnd: () => {
                        // set pagination color
                        const activeSlide = this.querySelector('.swiper-slide-active');
                        if(activeSlide){
                            const colorText = getComputedStyle(activeSlide).getPropertyValue('--color-text').trim();
                            this.style.setProperty('--color-pagination', `${colorText}`);
                        }

                        // check if active slide contains video and pause other videos
                        this.slides.forEach(slide => {
                            const video = slide.querySelector('video');
                            if(video){
                                if(slide.classList.contains('swiper-slide-active')){
                                    video.play();
                                }else{
                                    video.pause();
                                    video.currentTime = 0;
                                }
                            }
                        });
                    }
                }
            }

            if(this.querySelector(".swiper-navigation-wrapper")){
                swiperSettings.navigation = {
                    nextEl: this.querySelector('.button-next'),
                    prevEl: this.querySelector('.button-previous')
                }
            }

            if(this.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: this.querySelector('.swiper-pagination')
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();

            // Mark clone slides as inert so keyboard focus skips duplicates
            this.swiper.slides.forEach(slide => {
                if(slide.classList.contains('swiper-slide-duplicate')){
                    slide.setAttribute('inert', '');
                    slide.setAttribute('aria-hidden', 'true');
                }
            });

            // Re-apply inert to clones after Swiper updates (loop mode re-creates clones)
            this.swiper.on("slideChange", () => {
                this.swiper.slides.forEach(slide => {
                    if(slide.classList.contains('swiper-slide-duplicate')){
                        slide.setAttribute('inert', '');
                        slide.setAttribute('aria-hidden', 'true');
                    }
                });
            });

            this.swiper.on("resize", this.checkSwiperLock.bind(this));

            this.setupFocusListeners();
        }


        checkSwiperLock(){
            if(!this.querySelector(".swiper-pagination")) return;
            
            if(this.swiper.isLocked){
                this.querySelector(".swiper-pagination").classList.add('hidden');
            }else{
                this.querySelector(".swiper-pagination").classList.remove('hidden');
            }
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }

    customElements.define('product-card', ProductCard);
}